import React from "react";
import PageHero from "../components/PageHero";
import Contact from "../components/Contact";
import { IMAGES, OFFICES } from "../config/siteConfig";
import { SectionLabel } from "../components/Shared";

export default function ContactPage() {
  return (
    <>
      <PageHero
        label="Contact"
        title="Let's Connect."
        highlight="Say Hello."
        subtitle="Reach INRISOFT across UAE, India and Latin America for projects, development, software products and collaborations."
        image={IMAGES.hero}
      />
      <section className="bg-white py-16 md:py-20 border-b border-black/5" data-testid="offices-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <SectionLabel>Our Offices</SectionLabel>
          <h2 className="font-display text-3xl md:text-4xl tracking-tight text-[#111111] mb-10">
            UAE | India | Latin America
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            {OFFICES.map((o) => (
              <div key={o.region} className="p-7 border border-black/10 rounded-sm" data-testid={`office-${o.region.toLowerCase().replace(/\s+/g, "-")}`}>
                <p className="overline text-[10px] text-[#C62828] mb-3">{o.region}</p>
                {o.contact && <p className="font-body font-600 text-[#111] mb-2">{o.contact}</p>}
                <p className="font-body text-sm text-[#555] leading-relaxed">{o.address}</p>
                <p className="font-body text-sm text-[#111] mt-4">{o.email}</p>
                <p className="font-body text-sm text-[#555] mt-1">{o.phone}</p>
                {o.website && (
                  <a href={o.website} target="_blank" rel="noopener noreferrer" className="font-body text-sm text-[#C62828] mt-2 inline-block hover:underline">
                    {o.website.replace(/^https?:\/\//, "")}
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
      <Contact />
    </>
  );
}
